module.exports = __webpack_public_path__ + "img/prop-65.1e59c6bb.jpg";